var React = require('react');

function WestfieldDirectSwooshInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0DD9CB","d":"M10.191052,8 L20.2553436,18.2218623 C20.7320585,18.704524 21,19.3600647 21,20.0437247 C21,20.7273847 20.7320585,21.3829254 20.2553436,21.865587 L10.2771533,32 L6.19212241,32 L14.2928248,23.7651822 C14.4561108,23.5997533 14.5478783,23.3751351 14.5478783,23.1408907 C14.5478783,22.9066462 14.4561108,22.6820281 14.2928248,22.5165992 L0,8 L10.191052,8 Z M21.7550761,0 L34.8352033,13.1676832 C36.3882656,14.7322546 36.3882656,17.2677454 34.8352033,18.8323168 L21.7550761,32 L16.2190589,32 L25.6372292,22.4995106 C26.9379397,21.1882147 26.9379397,19.0641759 25.6372292,17.7528801 L8,0 L21.7550761,0 Z"}));
}

WestfieldDirectSwooshInline.defaultProps = {"viewBox":"0 0 36 32"};

module.exports = WestfieldDirectSwooshInline;

WestfieldDirectSwooshInline.default = WestfieldDirectSwooshInline;
